module.exports = __webpack_public_path__ + "static/media/accessoires-pantalon.d21d1466.jpg";